var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _polyline, _polyline2, _line35, _polyline3, _polyline4, _polyline5, _path, _line36, _line37, _line38, _line39, _polyline6, _polyline7, _line40, _polyline8, _line41, _polyline9, _line42, _line43, _line44, _polyline10, _polyline11, _polyline12, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _polyline13, _line54, _polyline14, _line55, _line56, _polyline15, _line57, _line58, _polyline16, _polyline17, _line59, _line60, _line61, _g, _line62, _line63, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloor1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1854.37 1589.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#6d6d6d;stroke-width:5px;}.cls-1,.cls-2,.cls-3{fill:none;stroke-miterlimit:10;}.cls-4{fill:#84bd00;}.cls-5{letter-spacing:-.01em;}.cls-6{font-size:20px;}.cls-6,.cls-7{font-family:Mundial-Thin, Mundial;font-weight:200;}.cls-8{letter-spacing:0em;}.cls-9{letter-spacing:0em;}.cls-10{letter-spacing:0em;}.cls-2{stroke-width:.5px;}.cls-2,.cls-3{stroke:#84bd00;}.cls-11{letter-spacing:-.01em;}.cls-12{letter-spacing:-.1em;}.cls-7{font-size:9px;}.cls-13{letter-spacing:0em;}.cls-14{letter-spacing:-.03em;}.cls-15{letter-spacing:-.02em;}.cls-16{letter-spacing:-.01em;}.cls-17{letter-spacing:0em;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 302.47,
    y1: 1069.22,
    x2: 318.56,
    y2: 970.46
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 298.52,
    y1: 1068.59,
    x2: 314.61,
    y2: 969.82
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 425.44,
    y1: 871.44,
    x2: 425.44,
    y2: 823.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.49,
    y1: 871.44,
    x2: 420.49,
    y2: 823.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 704.17,
    y1: 819.58,
    x2: 669.6,
    y2: 819.58
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 704.17,
    y1: 823.58,
    x2: 669.6,
    y2: 823.58
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 756.58,
    y1: 819.58,
    x2: 720.6,
    y2: 819.58
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 756.58,
    y1: 823.55,
    x2: 720.6,
    y2: 823.55
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 876.17,
    y1: 819.58,
    x2: 830.3,
    y2: 819.58
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 876.17,
    y1: 823.55,
    x2: 830.3,
    y2: 823.55
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 928.91,
    y1: 819.58,
    x2: 882.39,
    y2: 819.58
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 928.91,
    y1: 823.55,
    x2: 882.39,
    y2: 823.55
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.36,
    y1: 576.75,
    x2: 424.36,
    y2: 533.64
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.5,
    y1: 576.75,
    x2: 420.5,
    y2: 533.64
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 914.98,
    y1: 120.69,
    x2: 886.66,
    y2: 120.69
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 914.98,
    y1: 124.65,
    x2: 886.66,
    y2: 124.65
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 723.44,
    y1: 120.9,
    x2: 581.93,
    y2: 120.7
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 723.44,
    y1: 124.9,
    x2: 581.93,
    y2: 124.7
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 377.53,
    y1: 120.44,
    x2: 335.02,
    y2: 120.38
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 377.53,
    y1: 124.43,
    x2: 335.02,
    y2: 124.39
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 665.12,
    y1: 936.14,
    x2: 665.12,
    y2: 963.44
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 669.1,
    y1: 936.14,
    x2: 669.1,
    y2: 963.44
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 699.62,
    y1: 1041.55,
    x2: 728.2,
    y2: 1041.55
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 699.62,
    y1: 1037.54,
    x2: 728.2,
    y2: 1037.54
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.69,
    y1: 1027.67,
    x2: 618.69,
    y2: 999.32
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.68,
    y1: 1027.67,
    x2: 614.68,
    y2: 999.32
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 858.33,
    y1: 991.47,
    x2: 900.85,
    y2: 991.47
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 858.33,
    y1: 987.48,
    x2: 900.85,
    y2: 987.48
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1001.19,
    y1: 900.09,
    x2: 1029.56,
    y2: 900.14
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1001.2,
    y1: 896.06,
    x2: 1029.57,
    y2: 896.11
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1042.44,
    y1: 856.86,
    x2: 1042.44,
    y2: 828.51
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1038.45,
    y1: 856.86,
    x2: 1038.45,
    y2: 828.51
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 506.91,
    y1: 577.23,
    x2: 465.7,
    y2: 577.23
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 506.91,
    y1: 581.22,
    x2: 465.7,
    y2: 581.22
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "290 1464.67 860.65 1464.52 1647.3 1420.68 1558.13 1010.5 1033.48 122.11 914.98 122.66"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "723.44 122.89 813.24 123.01 886.66 122.67"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 377.54,
    y1: 122.44,
    x2: 581.93,
    y2: 122.71
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "424.86 531.15 420.69 531.15 328.97 479.77 290 122.33 335.02 122.38"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "813.46 124.38 813.46 577.93 506.91 579.22"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "316.59 970.15 328.77 895.41 420.09 872.32 525.38 872.32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M835.4,1464.53s170.56-55.8,170.56-174.46-.6-125.75-.6-125.75h-215.43s-15.99,82.15-112.46,115.52l-389.97,.39v-131.59l12.99-79.72"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 616.7,
    y1: 1278.81,
    x2: 616.7,
    y2: 1027.67
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 699.62,
    y1: 1039.55,
    x2: 619.11,
    y2: 1039.55
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 792.82,
    y1: 1039.55,
    x2: 728.2,
    y2: 1039.55
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 790.12,
    y1: 1163.22,
    x2: 790.34,
    y2: 1040.16
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "502.92 874.25 502.92 990.13 616.97 990.13"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "616.68 828.51 616.68 820.97 420.02 820.94"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 616.68,
    y1: 999.32,
    x2: 616.68,
    y2: 856.85
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "667.11 963.44 667.11 989.5 858.33 989.5"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 667.11,
    y1: 819.06,
    x2: 667.11,
    y2: 936.14
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "704.17 821.57 718.12 821.57 718.12 900.63"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 667.11,
    y1: 878.13,
    x2: 718.12,
    y2: 878.13
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 667.11,
    y1: 898.2,
    x2: 772.46,
    y2: 898.2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 770.03,
    y1: 819.79,
    x2: 770.03,
    y2: 1039.73
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "771.16 931.6 990.73 931.6 990.73 989.5 900.85 989.5"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "931.41 828.51 931.41 821.57 990.73 821.57 990.73 932.63"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "756.58 821.57 827.79 821.57 827.79 828.51"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 876.17,
    y1: 821.57,
    x2: 882.39,
    y2: 821.57
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 879.28,
    y1: 859.21,
    x2: 879.28,
    y2: 929.76
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 852.42,
    y1: 983.28,
    x2: 852.42,
    y2: 989.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 852.42,
    y1: 933.74,
    x2: 852.42,
    y2: 957.77
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 906.96,
    y1: 983.28,
    x2: 906.96,
    y2: 989.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 906.96,
    y1: 933.74,
    x2: 906.96,
    y2: 957.77
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 865.1,
    y1: 859.54,
    x2: 894.07,
    y2: 859.54
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 992.87,
    y1: 898.11,
    x2: 1001.19,
    y2: 898.11
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1029.57,
    y1: 898.11,
    x2: 1039.99,
    y2: 898.11
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1040.45 856.86 1040.45 990.13 1134.43 990.13 1134.43 868.69 1473.8 868.69"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 522.87,
    y1: 874.27,
    x2: 522.87,
    y2: 987.81
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1445.81 821.57 1040.45 821.57 1040.45 828.51"
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1136.17,
    y1: 990.13,
    x2: 1156.24,
    y2: 990.13
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1154.28,
    y1: 870.56,
    x2: 1154.28,
    y2: 992.63
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "465.7 579.22 422.5 579.22 422.5 652.99"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 905.11,
    y1: 591.35,
    x2: 922.88,
    y2: 612.19
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 908.32,
    y1: 588.93,
    x2: 925.99,
    y2: 609.81
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1040.45 821.57 1040.45 759.6 924.34 610.84"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "906.76 590.22 897.86 578.67 815.5 577.93"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 422.5,
    y1: 723.29,
    x2: 422.5,
    y2: 819.79
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 445.15,
    y1: 710.83,
    x2: 399.84,
    y2: 665.51
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 399.84,
    y1: 710.83,
    x2: 445.15,
    y2: 665.51
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.49,654.78c9.76,0,18.55,4.17,24.69,10.82l1.22-1.22c-6.42-7-15.65-11.4-25.9-11.4s-19.56,4.43-25.99,11.49l1.22,1.22c6.14-6.71,14.97-10.92,24.78-10.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.34,710.96c-6.14,6.75-15,10.99-24.84,10.99s-18.77-4.27-24.91-11.07l-1,1c6.43,7.01,15.65,11.41,25.91,11.41s19.42-4.37,25.84-11.33l-1-1Z"
  }))), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.66,
    y1: 856.85,
    x2: 618.66,
    y2: 828.51
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.68,
    y1: 856.85,
    x2: 614.68,
    y2: 828.51
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1042.45,
    y: 143.11,
    width: 8.95,
    height: 2.91,
    transform: "translate(67.98 542.83) rotate(-30)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1053.85,
    y: 162.85,
    width: 8.95,
    height: 2.91,
    transform: "translate(59.64 551.18) rotate(-30)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1065.55,
    y: 182,
    width: 8.95,
    height: 2.91,
    transform: "translate(51.63 559.59) rotate(-30)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1077.03,
    y: 201.87,
    width: 8.95,
    height: 2.91,
    transform: "translate(43.23 567.99) rotate(-30)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1088.88,
    y: 221.17,
    width: 8.95,
    height: 2.91,
    transform: "translate(35.17 576.5) rotate(-30)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1100.46,
    y: 240.59,
    width: 8.95,
    height: 2.91,
    transform: "translate(27.01 584.9) rotate(-30)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1111.79,
    y: 260.85,
    width: 8.95,
    height: 2.91,
    transform: "translate(18.4 593.27) rotate(-30)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1123.13,
    y: 280.49,
    width: 8.95,
    height: 2.91,
    transform: "translate(10.1 601.57) rotate(-30)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1134.93,
    y: 299.25,
    width: 8.95,
    height: 2.91,
    transform: "translate(2.3 609.99) rotate(-30)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1146.3,
    y: 318.95,
    width: 8.95,
    height: 2.91,
    transform: "translate(-6.03 618.32) rotate(-30)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1157.99,
    y: 339.19,
    width: 8.95,
    height: 2.91,
    transform: "translate(-14.58 626.87) rotate(-30)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1169.2,
    y: 358.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-22.52 635) rotate(-30)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1180.77,
    y: 377.56,
    width: 8.95,
    height: 2.91,
    transform: "translate(-30.71 643.4) rotate(-30)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1192.37,
    y: 397.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-38.92 651.82) rotate(-30)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1203.85,
    y: 416.57,
    width: 8.95,
    height: 2.91,
    transform: "translate(-47.13 660.17) rotate(-30)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1215.5,
    y: 436.14,
    width: 8.95,
    height: 2.91,
    transform: "translate(-55.35 668.61) rotate(-30)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1227.03,
    y: 455.62,
    width: 8.95,
    height: 2.91,
    transform: "translate(-63.55 676.99) rotate(-30)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1238.57,
    y: 475.09,
    width: 8.95,
    height: 2.91,
    transform: "translate(-71.73 685.37) rotate(-30)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1250.02,
    y: 494.74,
    width: 8.95,
    height: 2.91,
    transform: "translate(-80.03 693.73) rotate(-30)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1261.49,
    y: 514.31,
    width: 8.95,
    height: 2.91,
    transform: "translate(-88.27 702.08) rotate(-30)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1273.03,
    y: 533.81,
    width: 8.95,
    height: 2.91,
    transform: "translate(-96.48 710.46) rotate(-30)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1284.56,
    y: 553.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(-104.69 718.85) rotate(-30)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1296.21,
    y: 572.69,
    width: 8.95,
    height: 2.91,
    transform: "translate(-112.81 727.27) rotate(-30)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1307.52,
    y: 592.27,
    width: 8.95,
    height: 2.91,
    transform: "translate(-121.09 735.54) rotate(-30)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1319.22,
    y: 611.73,
    width: 8.95,
    height: 2.91,
    transform: "translate(-129.25 744) rotate(-30)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1330.84,
    y: 631.5,
    width: 8.95,
    height: 2.91,
    transform: "translate(-137.58 752.46) rotate(-30)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1342.14,
    y: 650.72,
    width: 8.95,
    height: 2.91,
    transform: "translate(-145.67 760.68) rotate(-30)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1353.7,
    y: 670.53,
    width: 8.95,
    height: 2.91,
    transform: "translate(-154.03 769.12) rotate(-30)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1365.33,
    y: 689.89,
    width: 8.95,
    height: 2.91,
    transform: "translate(-162.15 777.53) rotate(-30)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1376.74,
    y: 709.66,
    width: 8.95,
    height: 2.91,
    transform: "translate(-170.51 785.88) rotate(-30)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1388.39,
    y: 728.91,
    width: 8.95,
    height: 2.91,
    transform: "translate(-178.57 794.28) rotate(-30)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1399.91,
    y: 748.67,
    width: 8.95,
    height: 2.91,
    transform: "translate(-186.91 802.69) rotate(-30)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1411.33,
    y: 768.11,
    width: 8.95,
    height: 2.91,
    transform: "translate(-195.1 811.01) rotate(-30)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1423.08,
    y: 787.7,
    width: 8.95,
    height: 2.91,
    transform: "translate(-203.32 819.5) rotate(-30)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1434.43,
    y: 807.03,
    width: 8.95,
    height: 2.91,
    transform: "translate(-211.46 827.77) rotate(-30)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1446.11,
    y: 826.52,
    width: 8.95,
    height: 2.91,
    transform: "translate(-219.64 836.22) rotate(-30)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1457.64,
    y: 846.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-227.88 844.61) rotate(-30)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1470.05,
    y: 865.82,
    width: 8.95,
    height: 2.91,
    transform: "translate(-236.09 853.46) rotate(-30)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1480.86,
    y: 885.34,
    width: 8.95,
    height: 2.91,
    transform: "translate(-244.4 861.48) rotate(-30)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1492.44,
    y: 904.63,
    width: 8.95,
    height: 2.91,
    transform: "translate(-252.5 869.85) rotate(-30)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1503.73,
    y: 924.2,
    width: 8.95,
    height: 2.91,
    transform: "translate(-260.76 878.12) rotate(-30)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1515.38,
    y: 943.69,
    width: 8.95,
    height: 2.91,
    transform: "translate(-268.95 886.56) rotate(-30)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1526.74,
    y: 963.37,
    width: 8.95,
    height: 2.91,
    transform: "translate(-277.26 894.87) rotate(-30)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1538.29,
    y: 982.96,
    width: 8.95,
    height: 2.91,
    transform: "translate(-285.51 903.27) rotate(-30)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1549.82,
    y: 1002.18,
    width: 8.95,
    height: 2.91,
    transform: "translate(-293.58 911.61) rotate(-30)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1634.11,
    y: 1419.65,
    width: 8.95,
    height: 2.91,
    transform: "translate(311.93 3137.06) rotate(-93.23)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1619.07,
    y: 1420.8,
    width: 8.95,
    height: 2.91,
    transform: "translate(294.89 3123.25) rotate(-93.23)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1603.09,
    y: 1421.4,
    width: 8.95,
    height: 2.91,
    transform: "translate(277.42 3107.94) rotate(-93.23)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1580.47,
    y: 1422.98,
    width: 8.95,
    height: 2.91,
    transform: "translate(251.95 3087.02) rotate(-93.23)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1557.97,
    y: 1424.25,
    width: 8.95,
    height: 2.91,
    transform: "translate(226.92 3065.89) rotate(-93.23)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1535.23,
    y: 1425.53,
    width: 8.95,
    height: 2.91,
    transform: "translate(201.62 3044.54) rotate(-93.23)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1511.79,
    y: 1426.85,
    width: 8.95,
    height: 2.91,
    transform: "translate(175.55 3022.53) rotate(-93.23)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1489.81,
    y: 1428.09,
    width: 8.95,
    height: 2.91,
    transform: "translate(151.09 3001.9) rotate(-93.23)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1467.27,
    y: 1429.05,
    width: 8.95,
    height: 2.91,
    transform: "translate(126.31 2980.41) rotate(-93.23)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1444.15,
    y: 1430.66,
    width: 8.95,
    height: 2.91,
    transform: "translate(100.29 2959.02) rotate(-93.23)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1421.55,
    y: 1431.93,
    width: 8.95,
    height: 2.91,
    transform: "translate(75.14 2937.8) rotate(-93.23)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1399.47,
    y: 1432.85,
    width: 8.95,
    height: 2.91,
    transform: "translate(50.91 2916.73) rotate(-93.23)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1376.84,
    y: 1434.13,
    width: 8.95,
    height: 2.91,
    transform: "translate(25.74 2895.49) rotate(-93.23)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1354.15,
    y: 1435.41,
    width: 8.95,
    height: 2.91,
    transform: "translate(.49 2874.19) rotate(-93.23)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1331.12,
    y: 1436.7,
    width: 8.95,
    height: 2.91,
    transform: "translate(-25.14 2852.56) rotate(-93.23)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1308.62,
    y: 1437.97,
    width: 8.95,
    height: 2.91,
    transform: "translate(-50.17 2831.43) rotate(-93.23)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1286.05,
    y: 1439.24,
    width: 8.95,
    height: 2.91,
    transform: "translate(-75.27 2810.25) rotate(-93.23)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1263.54,
    y: 1440.51,
    width: 8.95,
    height: 2.91,
    transform: "translate(-100.32 2789.11) rotate(-93.23)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1240.94,
    y: 1441.79,
    width: 8.95,
    height: 2.91,
    transform: "translate(-125.46 2767.89) rotate(-93.23)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1218.27,
    y: 1443.06,
    width: 8.95,
    height: 2.91,
    transform: "translate(-150.68 2746.61) rotate(-93.23)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1195.76,
    y: 1444.33,
    width: 8.95,
    height: 2.91,
    transform: "translate(-175.73 2725.47) rotate(-93.23)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1173.62,
    y: 1445.58,
    width: 8.95,
    height: 2.91,
    transform: "translate(-200.36 2704.68) rotate(-93.23)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1150.71,
    y: 1446.87,
    width: 8.95,
    height: 2.91,
    transform: "translate(-225.85 2683.17) rotate(-93.23)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1127.71,
    y: 1448.17,
    width: 8.95,
    height: 2.91,
    transform: "translate(-251.43 2661.58) rotate(-93.23)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1105.06,
    y: 1449.44,
    width: 8.95,
    height: 2.91,
    transform: "translate(-276.63 2640.31) rotate(-93.23)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1081.72,
    y: 1450.76,
    width: 8.95,
    height: 2.91,
    transform: "translate(-302.6 2618.4) rotate(-93.23)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1059.43,
    y: 1452.02,
    width: 8.95,
    height: 2.91,
    transform: "translate(-327.39 2597.48) rotate(-93.23)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1036.6,
    y: 1453.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-352.79 2576.04) rotate(-93.23)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1014.25,
    y: 1454.56,
    width: 8.95,
    height: 2.91,
    transform: "translate(-377.67 2555.05) rotate(-93.23)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 991.8,
    y: 1455.83,
    width: 8.95,
    height: 2.91,
    transform: "translate(-402.64 2533.97) rotate(-93.23)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 969.24,
    y: 1457.1,
    width: 8.95,
    height: 2.91,
    transform: "translate(-427.74 2512.8) rotate(-93.23)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 946.03,
    y: 1458.1,
    width: 8.95,
    height: 2.91,
    transform: "translate(-453.26 2490.68) rotate(-93.23)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 923.92,
    y: 1459.35,
    width: 8.95,
    height: 2.91,
    transform: "translate(-477.86 2469.92) rotate(-93.23)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 901.17,
    y: 1460.63,
    width: 8.95,
    height: 2.91,
    transform: "translate(-503.16 2448.57) rotate(-93.23)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 878.75,
    y: 1461.9,
    width: 8.95,
    height: 2.91,
    transform: "translate(-528.11 2427.51) rotate(-93.23)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 858.69,
    y: 1463.21,
    width: 8.95,
    height: 2.91,
    transform: "translate(-550.62 2408.87) rotate(-93.23)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(1273.55 1200.04)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B\xFC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 24.53,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.46,
    y: 0
  }, "o"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(660.52 1153.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Heiz"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 39.38,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.4,
    y: 0
  }, "aum"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(382.25 1114.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ge"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 26.4,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.11,
    y: 0
  }, "erbe"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 84.38,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 91.39,
    y: 0
  }, "aum"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(573.57 962.87) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 9.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.02,
    y: 0
  }, "eppen"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(1094.21 962.87) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 9.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.02,
    y: 0
  }, "eppen"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(686.24 935.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Elekt"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 44.79,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.73,
    y: 0
  }, "o"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(691.23 956.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Raum"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(678.19 858.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lift"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(727.39 870.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lift"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(806.74 885.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(790.06 908.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Hee"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 37.39,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.33,
    y: 0
  }, "en"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(917.74 885.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(901.22 908.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Damen"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(645.79 716.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.5,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 23.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.58,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 45.86,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 58.12,
    y: 0
  }, "tion"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(1053.94 503.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B\xFC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 24.53,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.46,
    y: 0
  }, "o"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(483.5 351.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ge"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 26.4,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.11,
    y: 0
  }, "erbe"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 84.38,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 91.39,
    y: 0
  }, "aum"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(930.27 966.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(796 966.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(675.98 891.64)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1146.75 945.85) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(515.04 952.98) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(359.44 1383.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 0,
    y: 0
  }, "Z"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.84,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 23.45,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.35,
    y: 0
  }, "ahrt"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 67.58,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 71.3,
    y: 0
  }, "Ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 86.77,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 97.94,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 104.84,
    y: 0
  }, "ga"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 127.94,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 134.95,
    y: 0
  }, "age"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor1);
export default __webpack_public_path__ + "static/media/floor1.3d55487a6240d7471943738bb763443e.svg";
export { ForwardRef as ReactComponent };